import React from "react"
import { Redirect } from "react-router-dom"

// Authentication related pages
import Login from "../pages/Authentication/Login"
import Logout from "../pages/Authentication/Logout"
import ForgetPwd from "../pages/Authentication/ForgetPassword"

import UserProfiles from "../pages/Authentication/user-profile"

import Dashboard from "../pages/Dashboard"
import Company from "pages/Company"
import Subscriptions from "pages/Subscriptions"
import Transactions from "pages/Transactions"
import Configurations from "pages/Configurations/Index"
import PaymentGateway from "pages/PaymentGateway/Index"
import Notifications from "pages/Notifications/Index"
import LoginAdds from "pages/LoginAdds/Index"
import UniversalTemplates from "pages/UniversalTemplates"

import _404 from "pages/404"

const authProtectedRoutes = [
  { path: "/dashboard", component: Dashboard },
  { path: "/company", component: Company },
  { path: "/subscriptions", component: Subscriptions },
  { path: "/transactions", component: Transactions },
  { path: "/configurations", component: Configurations },
  { path: "/payment-gateway-configuration", component: PaymentGateway },
  { path: "/notifications", component: Notifications },
  { path: "/login-ads-management", component: LoginAdds },
  { path: "/universal-templates", component: UniversalTemplates },

  { path: "/profiles", component: UserProfiles },

  { path: "/document", component: Document },
  { path: "/documents/type", component: DocumentType },


  { path: "/", exact: true, component: () => <Redirect to="/dashboard" /> },
]

const publicRoutes = [
  { path: "/logout", component: Logout },
  { path: "/login", component: Login },
  { path: "/forgot-password", component: ForgetPwd },
]

export { authProtectedRoutes, publicRoutes }
